import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '.';

// Component Definition
const SmallBody: FC<TextProps> = props => (
  <Text
    fontSize="smallBody"
    {...props}
    className={classNames(props.className, 'text_small-body')}
  />
);

export default SmallBody;
